import { render, staticRenderFns } from "./addUpdateLeaderboard.vue?vue&type=template&id=8abf0022&scoped=true"
import script from "./addUpdateLeaderboard.vue?vue&type=script&lang=js"
export * from "./addUpdateLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./addUpdateLeaderboard.vue?vue&type=style&index=0&id=8abf0022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abf0022",
  null
  
)

export default component.exports